export const getUrlByRegion = (url: string, region?: number) => (region ? `${url}&region=${region}` : url);
